// removed by extract-text-webpack-plugin
module.exports = {"dataContainer":"_21d0tra5t6J-8a65k1P7qV","sectionTitle":"_3HVPBlQLaDumBvt5l1wcdU","preview":"_1XykVLBSaO0mufzSpg3-fk"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Resources/components/ResourcesGrid.mod.css
// module id = 1641
// module chunks = 0